/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_KeepInputs */

const en_settings_cancel_keep = /** @type {(inputs: Settings_Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep my plan`)
};

const id_settings_cancel_keep = /** @type {(inputs: Settings_Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetap berlangganan`)
};

/**
* | output |
* | --- |
* | "Keep my plan" |
*
* @param {Settings_Cancel_KeepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_keep = /** @type {((inputs?: Settings_Cancel_KeepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_KeepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_keep(inputs)
	return en_settings_cancel_keep(inputs)
});